import React from 'react';
import { ArrowLeft } from 'react-feather';
import UniqueIcon from '../../../assets/unique-method.png'

const Step5UniqueMethodOptions = ({ onSelectOption, onBackToSelection }) => {
  return (
    <div style={{
      maxWidth: '808px',
      width: '100%',
      background: '#fff',
      borderRadius: '10px',
      padding: '32px 36px',
    }}>
      <div style={{ marginBottom: '5px', display: 'flex', alignItems: 'center', gap: '10px' }}>
          <img src={UniqueIcon} alt="Unique Method" style={{ width: '22px', height: '22px' }} />
        <h5 style={{ fontWeight: '600', fontSize: '18px', marginBottom: '4px' }}>
          Unique Method
        </h5>
      </div>
      <p style={{ color: '#888', fontSize: '13px', marginBottom: '32px' }}>
        Select the category type to find the matches for your brand
      </p>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
        {/* Option 1 */}
        <div style={optionCardStyle}>
       
          <h6 style={optionTitleStyle}>Put Brand B Retailers in Brand A</h6>
          <p style={optionDescStyle}>
            Use Brand A as target space and inject retailers from Brand B
          </p>
          <button
            type="button"
            onClick={() => onSelectOption('put_brand_retailers')}
            style={selectBtnStyle}
          >
            Select
          </button>
        </div>

        {/* Option 2 */}
        <div style={optionCardStyle}>
          <h6 style={optionTitleStyle}>Take working with retailers</h6>
          <p style={optionDescStyle}>
            Take working with retailer from brands in your space
          </p>
          <button
            type="button"
            onClick={() => onSelectOption('take_working_retailers')}
            style={selectBtnStyle}
          >
            Select
          </button>
        </div>
      </div>

      {/* Back to selection link */}
      <div style={{ marginTop: '24px' }}>
        <button
          type="button"
          onClick={onBackToSelection}
          style={backLinkStyle}
        >
          <ArrowLeft size={14} />
          Back to selection
        </button>
      </div>
    </div>
  );
};

const optionCardStyle = {
  background: '#fff',
  border: '1px solid #e0e0e0',
  borderRadius: '8px',
  padding: '24px 20px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  textAlign: 'left',
};

const iconWrapperStyle = {
  marginBottom: '16px',
};

const iconCircleStyle = {
  width: '48px',
  height: '48px',
  borderRadius: '50%',
  background: '#f0f0f0',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '20px',
  fontWeight: '600',
  color: '#222',
};

const optionTitleStyle = {
  fontSize: '16px',
  fontWeight: '600',
  color: '#222',
  marginBottom: '8px',
};

const optionDescStyle = {
  fontSize: '13px',
  color: '#888',
  lineHeight: '1.5',
  marginBottom: '20px',
  minHeight: '60px',
};

const selectBtnStyle = {
  width: '100%',
  background: '#222',
  border: 'none',
  color: '#fff',
  fontSize: '13px',
  fontWeight: '500',
  padding: '10px 20px',
  borderRadius: '6px',
  cursor: 'pointer',
  transition: 'background 0.2s',
};

const backLinkStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  background: 'none',
  border: 'none',
  color: '#666',
  fontSize: '13px',
  cursor: 'pointer',
  padding: 0,
};

export default Step5UniqueMethodOptions;
